import { memo, useCallback, useState, CSSProperties } from 'react';
import IconCrossCircleFilled from '@picsart/icons/IconCrossCircleFilled';

import Loader from '../../../core/Loader';
import { AnalyticsGTM } from '../../../../services/analytics-gtm';
import { useLoginStore } from '../LoginStore';

import useStyles from './styles';
import getPopupUrl from './getPopupUrl';
import { useIframeCommunication } from './hooks';

type LoginPopupProps = {
  analytics: AnalyticsGTM;
};

function LoginPopup({ analytics }: LoginPopupProps) {
  const classes = useStyles();
  const closePopup = useLoginStore((state) => state.closePopup);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const close = useCallback(() => {
    setIframeLoaded(false);
    closePopup();
  }, []);

  const iframeStyles: CSSProperties = {};
  const loaderStyles: CSSProperties = {};
  if (iframeLoaded) {
    iframeStyles.display = 'block';
    loaderStyles.display = 'none';
  } else {
    iframeStyles.display = 'none';
    loaderStyles.display = 'block';
  }

  useIframeCommunication(close, analytics);

  return (
    <div className={classes.root}>
      <div className={classes.iframeContainer}>
        <iframe
          style={iframeStyles}
          className={classes.iframe}
          src={getPopupUrl()}
          onLoad={() => setIframeLoaded(true)}
        />
        <Loader className={classes.loader} style={loaderStyles} />
        <IconCrossCircleFilled className={classes.icon} onClick={close} />
      </div>
    </div>
  );
}

export default memo(LoginPopup);
